<template>
  <div class="home">
    <common-header
      ref="header"
      :type="1"
      :isFixed="false"
      :active="1"
      :showOrg="false"
    ></common-header>
    <common-header
      ref="header"
      :active="1"
      :showOrg="false"
      class="ta3"
      :style="scrollTop > 698 ? 'opacity: 1' : 'opacity: 0;z-index:-1;'"
      v-show="scrollTop > 200"
    ></common-header>
    <div class="main">
      <div class="home_top_box">
        <div class="home_top">
          <div class="lib_introduce">
            <div class="my_lib toh2">
              {{
                userData.lib_id == 744
                  ? "肇庆学院（IP登录）"
                  : userData.lib_name
                  ? `${userData.lib_name}欢迎您`
                  : "翼狐设计学习库欢迎您"
              }}
            </div>
            <div class="introduce_item">
              <img
                src="@/assets/images/home/homg_top1.svg"
                alt=""
              />海量优质内容
            </div>
            <div class="introduce_item">
              <img
                src="@/assets/images/home/homg_top2.svg"
                alt=""
              />涵盖60+软件技能学习
            </div>
            <div class="introduce_item">
              <img
                src="@/assets/images/home/homg_top3.svg"
                alt=""
              />专业讲师精心推荐的软件学习宝典
            </div>
            <div class="introduce_item">
              <img
                src="@/assets/images/home/homg_top4.svg"
                alt=""
              />1000万+学员共同选择
            </div>
          </div>
          <div class="top_main">
            <div class="top_main_left" @mouseleave="activeIndex = null">
              <ul class="left_classify">
                <li
                  v-for="(e, i) in industryData"
                  :key="e.vic_id"
                  :class="activeIndex == i ? 'ind_active' : ''"
                  @mouseover="
                    industryIndex = i;
                    activeIndex = i;
                  "
                >
                  <img
                    class="l_n"
                    :src="
                      require(`@/assets/images/home/classify_icon${i + 1}.svg`)
                    "
                    alt=""
                  />
                  <img
                    class="l_a"
                    :src="
                      require(`@/assets/images/home/classify_icon_a${
                        i + 1
                      }.svg`)
                    "
                    alt=""
                  />
                  <span>{{ e.vic_name }}</span>
                </li>
              </ul>
              <div class="classify_details" v-if="industryData.length">
                <div class="industry_skill">
                  <div class="details_title">
                    <img src="@/assets/images/home/industry.png" alt="" />
                    行业技能
                  </div>
                  <ul class="industry_skill_det">
                    <li
                      v-for="e in industryData[industryIndex].red_album"
                      :key="e.vic_id"
                      @click="
                        goIndustry(industryData[industryIndex].vic_id, e.vic_id)
                      "
                    >
                      {{ e.vic_name }}
                    </li>
                  </ul>
                </div>
                <div class="software_teach">
                  <div class="details_title">
                    <img
                      src="@/assets/images/home/software.png"
                      alt=""
                    />软件教学
                  </div>
                  <ul class="software_teach_det">
                    <li
                      v-for="e in industryData[industryIndex].soft_arr"
                      :key="e.soft_id"
                      @click="goSoftware(e.soft_id)"
                    >
                      <div
                        class="li_img"
                        :style="`background:url(${e.soft_img})`"
                      ></div>
                      <span class="toh">
                        {{ e.soft_name }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="top_main_swiper">
              <swiper :options="bannerOptions">
                <swiper-slide v-for="e in bannerInfo" :key="e.flash_id">
                  <a
                    :href="e.http_url"
                    class="banner_item"
                    :style="`background:url(${e.banner_img}) center center no-repeat`"
                  >
                  </a>
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
            <div class="top_main_right">
              <div class="no_login" v-if="!token && !nick">
                <div class="no_login_top">
                  <p class="dfAcJc">
                    <img
                      src="@/assets/images/home/login_icon1.svg"
                      alt=""
                    />登录后你可以
                  </p>
                </div>
                <div class="no_login_bottom">
                  <div class="login_info">
                    <p>
                      <img
                        src="@/assets/images/home/login_icon2.svg"
                        alt=""
                      />同步学习记录
                    </p>
                    <p>
                      <img
                        src="@/assets/images/home/login_icon3.svg"
                        alt=""
                      />下载素材文件
                    </p>
                    <p>
                      <img
                        src="@/assets/images/home/login_icon4.svg"
                        alt=""
                      />参加有奖活动
                    </p>
                    <p>
                      <img
                        src="@/assets/images/home/login_icon5.svg"
                        alt=""
                      />获取更多精彩内容
                    </p>
                  </div>

                  <div class="user_btn" @click="login()">登录</div>
                </div>
              </div>
              <div class="user_box" v-else>
                <div class="user_info">
                  <img
                    :src="userData.member_head"
                    alt=""
                    class="user_portrait"
                  />
                  <p class="user_name">{{ userData.member_name }}</p>
                  <p class="user_org">{{ userData.lib_name }}</p>
                </div>
                <div class="user_study">
                  <p class="user_time dfAic">
                    在学课程：<span style="color: #22b79e; margin-right: 5px">{{
                      userData.albumtotal_count
                    }}</span>
                    门
                  </p>
                  <p class="user_time dfAic">
                    已学课时：<span style="color: #22b79e; margin-right: 5px">{{
                      userData.coursetotal_count
                    }}</span>
                    课时
                  </p>
                  <p class="user_time dfJsbAc" v-if="userData.member_type != 9">
                    累计学习：<span style="color: #22b79e">{{
                      userData.study_time_hour
                    }}</span>
                    小时
                    <span style="color: #22b79e">{{
                      userData.study_time_min
                    }}</span>
                    分钟
                  </p>
                  <p class="user_time dfJsbAc" v-if="userData.member_type != 9">
                    本月学习：<span style="color: #22b79e">{{
                      userData.duration_time_hour
                    }}</span>
                    小时
                    <span style="color: #22b79e">{{
                      userData.duration_time_min
                    }}</span>
                    分钟
                  </p>

                  <a
                    href="https://lib.yiihuu.com/personal/study_list.php"
                    class="user_btn"
                    >我的课程</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main_box">
        <div class="bg_b">
          <ai-agent :aiAgent="aiAgent" @show-login="login"></ai-agent>
        </div>
        <div>
          <!-- 最新教程 -->
          <new-course :newData="newData"></new-course>
          <!-- 行业教程推荐 -->
          <industry-course></industry-course>
        </div>
        <div class="bg_a" style="overflow: hidden">
          <!-- 学习宝典 -->
          <study-bible :bibleData="bibleData"></study-bible>
          <!-- 学习路径 -->
          <study-path></study-path>
        </div>
        <div>
          <!-- 学习专题 -->
          <study-subject></study-subject>
          <!-- 秒学设计 -->
          <study-note :noteData="noteData"></study-note>
          <!-- 学习排行榜 -->
          <study-charts></study-charts>
        </div>
        <div class="bg_a">
          <!-- 比赛活动 -->
          <act-list></act-list>
          <!-- 学员作品 -->
          <student-work></student-work>
        </div>
        <div>
          <!-- 在线设计 -->
          <online-design></online-design>
          <!-- 图文资讯 -->
          <photo-news></photo-news>
        </div>
      </div>
    </div>
    <common-footer></common-footer>
    <rtbox></rtbox>

    <el-dialog
      :visible.sync="awardVisible"
      top="20vh"
      :modal-append-to-body="false"
      :before-close="goMyAct"
      width="439px"
      class="award_dialog"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="award_details">
        <div class="close_btn" @click="awardVisible = false"></div>
        <div class="award_act">恭喜你在{{ awardActTitle }}中获奖啦！</div>
        <div class="award_btn" @click="goMyAct">查看获奖情况</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken, getNick } from "@/utils/auth.js";
import aiAgent from "./components/aiAgent";
import newCourse from "./components/newCourse";
import industryCourse from "./components/industryCourse";
import studyPath from "./components/studyPath";
import studyBible from "./components/studyBible";
import studySubject from "./components/studySubject";
import studyNote from "./components/studyNote";
import studyCharts from "./components/studyCharts";
import actList from "./components/actList";
import studentWork from "./components/studentWork";
import onlineDesign from "./components/onlineDesign";
import photoNews from "./components/photoNews";
import { getIndexNew, getLibWorkPriceLog } from "@/api/home";
import { browserRedirectHome } from "@/api/common";
export default {
  name: "home",
  components: {
    aiAgent,
    newCourse,
    industryCourse,
    studyPath,
    studyBible,
    studySubject,
    studyNote,
    studyCharts,
    actList,
    studentWork,
    onlineDesign,
    photoNews,
  },
  data() {
    return {
      token: getToken(),
      nick: getNick(),
      // swiper
      bannerOptions: {
        initialSlide: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 解决分页器点击无效的bug
        },
        observer: true,
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true, // 循环模式选项
        autoplay: {
          // 默认为false
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false, // 触碰后是否继续自动切换
        },
      },
      scrollTop: 0,
      // 智能体列表
      aiAgent: [],
      // 最新列表
      newData: [],
      // 活动列表
      actData: [],
      // 宝典列表
      bibleData: [],
      // 笔记列表
      noteData: [],
      // 行业列表
      industryData: [],
      industryIndex: 0,
      activeIndex: null,
      // 用户信息
      userData: {},
      // 轮播图列表
      bannerInfo: [],
      // 获奖通知
      awardVisible: false,
      // 获奖活动
      awardActTitle: "",
    };
  },
  created() {
    this.getHomeNew();
    this.getAward();
  },
  mounted() {
    if (this.$route.query.perType) {
      this.$refs.header.showPerDialog(Number(this.$route.query.perType));
    }
    browserRedirectHome("/");
    let that = this;
    window.onscroll = function () {
      //为了保证兼容性，这里取两个值，哪个有值取哪一个
      that.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
    };
  },
  methods: {
    login() {
      this.$refs.header.showLogin();
    },
    getHomeNew() {
      getIndexNew().then((res) => {
        res.data.industry_data.splice(9);
        this.industryData = res.data.industry_data;
        this.userData = res.data.user_data;
        this.bannerInfo = res.data.banner_info;
        this.newData = res.data.new_data;
        this.aiAgent = res.data.ai_agents;
        this.bibleData = res.data.bible_data;
        this.noteData = res.data.notes;
      });
    },
    goIndustry(id, childId) {
      location.href = `https://lib.yiihuu.com/list/industry.php?s=3-0-0-0-${id}-${childId}-0-0-0`;
    },
    goSoftware(id) {
      location.href = `https://lib.yiihuu.com/list/index.php?s=2-0-0-${id}--0-0-0-0`;
    },
    // 获奖弹框
    getAward() {
      getLibWorkPriceLog().then((res) => {
        if (res.data.length) {
          this.awardVisible = true;
          if (res.data.length > 1) {
            this.awardActTitle = "多个比赛活动";
          } else {
            this.awardActTitle = "比赛活动【" + res.data[0][0].ac_name + "】";
          }
        }
      });
    },
    goMyAct() {
      this.$router.replace("/u/myAct/");
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  background: #fff;
  .main {
    margin-top: -76px;
    .home_top_box {
      width: 100%;
      height: 698px;
      padding-top: 76px;
      background: url("@/assets/images/home/home_top_bg.png") center center
        no-repeat;
      .home_top {
        width: 1380px;
        margin: 0 auto;
        .lib_introduce {
          margin-left: 43px;
          display: flex;
          align-items: center;
          font-size: 14px;
          line-height: 19px;
          color: #a7a7a7;
          letter-spacing: 1px;
          margin-top: 21px;
          position: relative;
          &::before {
            content: "";
            display: block;
            width: 34px;
            height: 59px;
            background: url("@/assets/images/home/top_org.svg");
            position: absolute;
            top: -21px;
            left: -43px;
          }
          .my_lib {
            width: 184px;
            margin-right: 23px;
          }
          .introduce_item {
            margin-right: 48px;
            img {
              width: 22px;
              height: 22px;
              margin-right: 8px;
            }
          }
        }
        .top_main {
          margin-top: 51px;
          display: flex;
          justify-content: space-between;
          .top_main_left {
            width: 227px;
            height: 450px;
            position: relative;
            z-index: 2;
            .left_classify {
              background: #333;
              border-radius: 10px;
              overflow: hidden;
              li {
                width: 100%;
                height: 50px;
                text-align: center;
                line-height: 50px;
                color: #fff;
                border-bottom: 1px dashed #3f3f3f;
                cursor: pointer;
                position: relative;
                transition: 0.3s;
                font-size: 16px;
                &:last-child {
                  border-bottom: none;
                }
                &::before {
                  content: "";
                  display: inline-block;
                  position: absolute;
                  width: 0;
                  height: 100%;
                  background: linear-gradient(
                    89deg,
                    #1adc8a 0%,
                    rgba(35, 180, 160, 0.6) 100%
                  );
                  opacity: 0.33;
                  top: 0;
                  left: auto;
                  right: 0;
                  transition: 0.3s;
                }
                &:hover {
                  font-weight: 600;
                  color: #00cea8;
                  &::before {
                    width: 100%;
                    left: 0;
                    right: auto;
                  }
                  .l_n {
                    opacity: 0;
                  }
                  .l_a {
                    opacity: 1;
                  }
                }
                img {
                  width: 26px;
                  height: 26px;
                  margin-right: 9px;
                  transition: 0.3s;
                }
                .l_n {
                  opacity: 1;
                }
                .l_a {
                  opacity: 0;
                  margin-left: -35px;
                }
                span {
                  display: inline-block;
                  width: 65px;
                  text-align: left;
                }
              }
              .ind_active {
                font-weight: 600;
                color: #00cea8;
                &::before {
                  width: 100%;
                  left: 0;
                  right: auto;
                }
                .l_n {
                  opacity: 0;
                }
                .l_a {
                  opacity: 1;
                }
              }
            }
            .classify_details {
              width: 0;
              height: 100%;
              background: #fff;
              border-radius: 0 10px 10px 0;
              position: absolute;
              top: 0;
              left: 227px;
              transition: 0.3s;
              overflow-y: auto;
              &::-webkit-scrollbar {
                /*滚动条整体样式*/
                /*高宽分别对应横竖滚动条的尺寸*/
                width: 8px;
                height: 1px;
              }
              &::-webkit-scrollbar-thumb {
                /*滚动条里面小方块*/
                border-radius: 10px;
                -webkit-box-shadow: inset 0 0 5px #cccccc;
                background: #cccccc;
              }
              &::-webkit-scrollbar-track {
                /*滚动条里面轨道*/
                -webkit-box-shadow: inset 0 0 5px #e5e5e5;
                border-radius: 0px 0px 10px 10px;
                background: #e5e5e5;
              }
              .details_title {
                width: 100%;
                height: 51px;
                margin-top: 8px;
                font-size: 20px;
                font-weight: 600;
                line-height: 27px;
                color: #22b79e;
                letter-spacing: 1px;
                border-bottom: 1px solid #f0f0f0;
                display: flex;
                align-items: center;
                img {
                  width: 22px;
                  height: 22px;
                  margin-right: 6px;
                }
              }
              .industry_skill {
                width: 680px;
                .industry_skill_det {
                  margin-top: 4px;
                  display: flex;
                  flex-wrap: wrap;
                  li {
                    font-size: 16px;
                    line-height: 21px;
                    color: #333;
                    letter-spacing: 1px;
                    margin-top: 16px;
                    cursor: pointer;
                    transition: 0.3s;
                    &::after {
                      content: "";
                      display: inline-block;
                      width: 1px;
                      height: 14px;
                      margin: 0 26px;
                      background: #707070;
                    }
                    &:last-child {
                      &::after {
                        display: none;
                      }
                    }
                    &:hover {
                      color: #22b79e;
                    }
                  }
                }
              }
              .software_teach {
                width: 680px;
                margin-top: 10px;
                .software_teach_det {
                  margin-top: 8px;
                  display: flex;
                  flex-wrap: wrap;
                  li {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 155px;
                    height: 56px;
                    background: #fff;
                    border-radius: 28px;
                    margin: 12px 20px 0 0;
                    border: 1px solid #f0f0f0;
                    transition: 0.3s;
                    cursor: pointer;
                    &:nth-child(4n) {
                      margin-right: 0;
                    }
                    &:hover {
                      background: linear-gradient(
                        90deg,
                        #1adc8a 0%,
                        #23b4a0 100%
                      );
                      border: none;
                      color: #fff;
                      font-weight: bold;
                    }
                    .li_img {
                      width: 32px;
                      height: 32px;
                      margin-right: 5px;
                      border-radius: 50%;
                      background-size: 200% 100% !important;
                      background-position: center center !important;
                    }
                    span {
                      width: 80px;
                    }
                  }
                }
              }
            }
            &:hover {
              .classify_details {
                width: 740px;
                padding: 0 30px 20px;
              }
            }
          }
          .top_main_swiper {
            width: 894px;
            height: 450px;
            .swiper-container {
              width: 100%;
              height: 100%;
              border-radius: 10px;
              ::v-deep .swiper-pagination {
                .swiper-pagination-bullet-active {
                  background-color: #fff;
                }
              }
              .banner_item {
                display: block;
                width: 100%;
                height: 100%;
                background-size: auto 100% !important;
              }
            }
          }
          .top_main_right {
            width: 227px;
            height: 450px;
            background: #fff;
            border-radius: 10px;
            overflow: hidden;
            transition: 0.3s;
            position: relative;
            .no_login {
              .no_login_top {
                width: 100%;
                height: 120px;
                background: url("@/assets/images/home/login_bg.png");
                p {
                  font-size: 16px;
                  font-weight: bold;
                  color: #fff;
                  text-shadow: 0 0 6px #00a88c;
                  letter-spacing: 1px;
                  padding-top: 43px;
                  img {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    margin-right: 10px;
                    box-shadow: 0 3px 6px #22b79e;
                  }
                }
              }
              .no_login_bottom {
                width: 100%;
                margin-top: 28px;
                .login_info {
                  margin-left: 29px;
                  p {
                    font-size: 16px;
                    line-height: 21px;
                    color: #888;
                    margin-bottom: 30px;
                    &:last-child {
                      margin-bottom: 0;
                    }
                    img {
                      width: 24px;
                      height: 24px;
                      margin-right: 16px;
                    }
                  }
                }
              }
            }
            .user_box {
              .user_info {
                width: 100%;
                height: 163px;
                background: url("@/assets/images/home/login_bg.png");
                background-size: 100% 100%;
                text-align: center;
                padding-top: 20px;
                .user_portrait {
                  width: 80px;
                  height: 80px;
                  border-radius: 50%;
                  background: #f0f0f0;
                }
                .user_name {
                  font-size: 16px;
                  font-weight: bold;
                  line-height: 21px;
                  color: #333333;
                  margin-top: 10px;
                }
                .user_org {
                  font-size: 12px;
                  line-height: 16px;
                  color: #105f52;
                  margin-top: 2px;
                }
              }
              .user_study {
                text-align: center;

                .user_time {
                  padding: 0 18px;
                  margin-top: 22px;
                  font-size: 14px;
                  &:first-child {
                    margin-top: 34px;
                  }
                }
              }
            }
            .user_btn {
              width: 206px;
              height: 36px;
              font-weight: 400;
              color: #fff;
              font-size: 16px;
              background: linear-gradient(
                90deg,
                #1adc8a 0%,
                #23b4a0 50%,
                #1adc8a 100%
              );
              background-size: 200% 100%;
              border-radius: 100px;
              line-height: 36px;
              text-align: center;
              cursor: pointer;
              transition: all 0.3s;
              position: absolute;
              bottom: 40px;
              left: 50%;
              transform: translateX(-50%);
              &:hover {
                background-position: -100% 0;
              }
            }
          }
        }
      }
    }
    .main_box {
      .bg_a {
        background: #f4f4f4;
      }
      .bg_b {
        background: #f1f4fa;
      }
    }
  }
}

@media screen and (max-width: 1500px) and (min-width: 270px) {
  .home .main .home_top_box {
    height: 604px;
    .home_top {
      width: 1100px;
      .top_main {
        margin-top: 50px;
        .top_main_left {
          width: 181px;
          height: 359px;
          &:hover {
            .classify_details {
              width: 604px;
              padding: 0 24px 15px 30px;
            }
          }
          .left_classify {
            li {
              height: 40px;
              line-height: 40px;
              font-size: 13px;
              img {
                width: 20px;
                height: 20px;
                margin-right: 8px;
              }
              .l_a {
                margin-left: -28px;
              }
            }
          }
          .classify_details {
            left: 181px;
            .details_title {
              font-size: 16px;
              img {
                width: 20px;
                height: 20px;
              }
            }
            .industry_skill {
              width: 550px;
              .industry_skill_det {
                li {
                  font-size: 13px;
                  &::after {
                    margin: 0 15px;
                  }
                }
              }
            }
            .software_teach {
              width: 550px;
              .software_teach_det {
                li {
                  font-size: 13px;
                  width: 130px;
                  height: 42px;
                  margin: 12px 10px 0 0;
                  .li_img {
                    width: 20px;
                    height: 20px;
                  }
                }
              }
            }
          }
        }
        .top_main_swiper {
          width: 712px;
          height: 359px;
        }
        .top_main_right {
          width: 181px;
          height: 359px;
          .no_login {
            .no_login_top {
              height: 96px;
              p {
                font-size: 12px;
                padding-top: 38px;
                img {
                  width: 20px;
                  height: 20px;
                }
              }
            }
            .no_login_bottom {
              .login_info {
                p {
                  font-size: 12px;
                  margin-bottom: 20px;
                  img {
                    width: 20px;
                    height: 20px;
                    margin-right: 16px;
                  }
                }
              }
            }
          }
          .user_box {
            .user_info {
              height: 130px;
              padding-top: 16px;
              .user_portrait {
                width: 64px;
                height: 64px;
              }
              .user_name {
                font-size: 14px;
                line-height: 17px;
                margin-top: 8px;
              }
            }
            .user_study {
              .user_time {
                font-size: 12px;
                padding: 0 14px;
                margin-top: 17px;
                &:first-child {
                  margin-top: 26px;
                }
              }
            }
          }
          .user_btn {
            width: 163px;
            height: 29px;
            line-height: 29px;
            margin-top: 33px;
            font-size: 14px;
            bottom: 30px;
          }
        }
      }
      .lib_introduce {
        letter-spacing: 0;
        .my_lib {
          width: 164px;
        }
        .introduce_item {
          margin-right: 44px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
::v-deep .award_dialog {
  .el-dialog {
    height: 285px;
    border-radius: 10px !important;
    .el-dialog__header {
      padding: 0;
      &::after {
        display: none;
      }
    }
    .el-dialog__body {
      padding: 0;
      width: 100%;
      height: 100%;

      .award_details {
        width: 100%;
        height: 100%;
        background-image: url("@/assets/images/awards/award_bg.png");
        background-size: 100% 100%;
        padding-top: 160px;
        text-align: center;
        border-radius: 10px;
        position: relative;
        .close_btn {
          width: 24px;
          height: 24px;
          background-image: url("@/assets/images/awards/close.png");
          position: absolute;
          right: -20px;
          top: -20px;
          cursor: pointer;
        }
        .award_act {
          font-size: 14px;
          line-height: 25px;
          color: #000;
          width: 394px;
          margin: 0 auto;
          text-align: left;
        }
        .award_btn {
          cursor: pointer;
          margin: 15px auto;
          text-align: center;
          width: 125px;
          height: 38px;
          background: #1ad88c;
          border-radius: 5px;
          font-size: 14px;
          line-height: 38px;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
